import { getOSName, OSName } from '../../util';
export const PLATFORMS = ['win', 'mac', 'ios', 'linux'];
export const getActionsByKey = (key, shortcuts, platform) => {
  const result = [];
  if (!key) return result;
  if (!platform) {
    let os = getOSName();
    if (os === OSName.Unknown) os = OSName.Win;
    platform = os.toLowerCase();
  }
  for (const i in shortcuts) {
    if (shortcuts.hasOwnProperty(i)) {
      const group = shortcuts[i];
      const actionList = group.actions;
      for (const j in actionList) {
        if (actionList.hasOwnProperty(j)) {
          const action = actionList[j];
          const defaults = action.default[platform];
          let keys = action[platform];
          if (!keys && defaults) {
            keys = defaults;
          }
          if (keys && keys.indexOf(key) !== -1) {
            result.push(j);
          }
        }
      }
    }
  }
  return result;
};
export const importShortcuts = (base, userDefined) => {
  for (const i in base) {
    if (base.hasOwnProperty(i)) {
      const userDefinedGroup = userDefined[i];
      if (!userDefinedGroup || !userDefinedGroup.actions) continue;
      const group = base[i];
      const actionList = group.actions;
      const userDefinedActions = userDefinedGroup.actions;
      for (const j in actionList) {
        if (actionList.hasOwnProperty(j)) {
          const userDefinedAction = userDefinedActions[j];
          if (!userDefinedAction) continue;
          const action = actionList[j];
          PLATFORMS.forEach(p => {
            action[p] = userDefinedAction[p]?.map(value => value.toLowerCase());
            if (action.editable === false && action[p]) {
              action[p][0] = action.default[p][0];
            }
          });
        }
      }
    }
  }
};
export const filter = (shortcuts, filterList) => {
  const result = {};
  for (const i in shortcuts) {
    if (shortcuts.hasOwnProperty(i)) {
      const group = shortcuts[i];
      const actionList = group.actions;
      let resultGroup = undefined;
      for (const j in actionList) {
        if (actionList.hasOwnProperty(j)) {
          if (filterList.includes(j)) {
            if (resultGroup === undefined) {
              resultGroup = {
                actions: {},
                description: group.description
              };
            }
            resultGroup.actions[j] = actionList[j];
          }
        }
      }
      if (resultGroup) {
        result[i] = resultGroup;
      }
    }
  }
  return result;
};
export const getUserDefined = shortcuts => {
  const userDefined = {};
  for (const i in shortcuts) {
    if (shortcuts.hasOwnProperty(i)) {
      const group = shortcuts[i];
      const actionList = group.actions;
      userDefined[i] = {
        actions: {}
      };
      for (const j in actionList) {
        if (actionList.hasOwnProperty(j)) {
          const action = actionList[j];
          const userDefinedAction = {};
          PLATFORMS.forEach(function (p) {
            if (action[p] && action[p]?.length) {
              userDefinedAction[p] = action[p];
            }
          });
          if (Object.keys(userDefinedAction).length) userDefined[i].actions[j] = userDefinedAction;
        }
      }
    }
  }
  return userDefined;
};
//# sourceMappingURL=utils.js.map